export const constant = {
    product: "product",
    groupName: "groupName",
    username: "username",
    name_page: "Hoài Giang Shop",
    title_page: "Hoài Giang shop - Chuyên may, bán và cho thuê trang phục",
    description_page: "Hoài Giang shop chuyên may bán, thiết kế các loại trang phục áo dài, công sở, biểu diễn, hóa trang, dân tộc... chất lượng cho quý khách với giá cả hợp lý.",
    url_fav: "/asset/icon/favicon.ico",
    url_logo: process.env.SITE_URL + "asset/icon/logo.webp",
    address_page: "11 Võ Trường Toản, Phường 2, Bình Thạnh, Hồ Chí Minh 70000",
}